import { CallCalling } from 'iconsax-react';
import PropTypes from 'prop-types';
import close from '../../assets/images/close.svg';
import bannerExemple from '../../assets/images/exemp-banner.jpg';
import profileExemple from '../../assets/images/exemp.jpg';
import home from '../../assets/images/home.svg';
import card from '../../assets/images/icons/card.svg';
import pix from '../../assets/images/icons/pix.svg';
import svgLocation from '../../assets/images/location.svg';
import money from '../../assets/images/money.svg';
import passport from '../../assets/images/passport.svg';
import Text from '../../assets/styles/Text';
import ReactPortal from '../ReactPortal';
import * as styles from './styles';

export default function PopUpPlan({
  show,
  onClose,
  type,
  signature,
  upgrade = 0,
}) {
  if (!show) return null;

  const modelIs2 = type === 2;
  const modelIs3 = type === 3;
  const model2and3 = modelIs2 || modelIs3;

  return (
    <ReactPortal containerId="PopUpPlan">
      <styles.Modal>
        <styles.Group>
          <button type="button" className="close" onClick={onClose}>
            <img src={close} alt="close" />
          </button>

          <styles.Container
            $bost={upgrade === 3}
            $modelIs2={modelIs2}
            $modelIs3={modelIs3}
          >
            <div>
              <styles.Banner $banner={bannerExemple} />

              <styles.GroupInfos>
                <styles.GroupImgDescription $margin={type}>
                  <styles.ImgDescription $img={profileExemple} />

                  {model2and3 && (
                    <Text.Span>Descrição de sua preferência!</Text.Span>
                  )}
                </styles.GroupImgDescription>

                <styles.Infos>
                  <Text.H4 $bold title="Seu apelido">
                    Seu apelido
                  </Text.H4>

                  <styles.GroupText $bost={upgrade === 3}>
                    <img src={money} alt="icon" />
                    <Text.P $bold className="price">
                      R$X / X hora
                    </Text.P>
                  </styles.GroupText>

                  <styles.GroupText $bost={upgrade === 3}>
                    <img src={passport} alt="icon" className="bottom" />
                    <Text.Span>Sua idade</Text.Span>
                  </styles.GroupText>

                  {model2and3 && (
                    <>
                      <styles.GroupText $bost={upgrade === 3}>
                        <img src={home} alt="icon" className="width" />
                        <Text.Span>Presencial</Text.Span>
                      </styles.GroupText>

                      <styles.GroupText $bost={upgrade === 3}>
                        <img
                          src={svgLocation}
                          alt="icon"
                          className="location"
                        />
                        <Text.Span>Sua cidade</Text.Span>
                      </styles.GroupText>
                    </>
                  )}
                </styles.Infos>
              </styles.GroupInfos>

              {modelIs3 && (
                <styles.GroupButton $bost={upgrade === 3}>
                  <a href="##">
                    <CallCalling />
                    <Text.H4>Telefone</Text.H4>
                  </a>
                </styles.GroupButton>
              )}
            </div>
          </styles.Container>

          <styles.GroupPayment>
            <Text.Span $bold>
              {signature
                ? 'Pague sua assinatura com cartão de crédito, de forma segura e renovação automática'
                : 'Pague seu plano com cartão de crédito ou Pix, de forma segura'}
            </Text.Span>

            <div>
              <small>
                <img src={card} alt="card" />
                Cartão
              </small>

              {!signature && (
                <small>
                  <img src={pix} alt="pix" />
                  Pix
                </small>
              )}
            </div>
          </styles.GroupPayment>

          <styles.PaymentButton>
            <Text.H4>QUERO ESSA ASSINATURA</Text.H4>
          </styles.PaymentButton>
        </styles.Group>
      </styles.Modal>
    </ReactPortal>
  );
}

PopUpPlan.propTypes = {
  show: PropTypes.bool.isRequired,
  signature: PropTypes.bool.isRequired,
  upgrade: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.array.isRequired,
};
